import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';
import CircularProgress from '@mui/material/CircularProgress';
import { Link } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import AsyncSelect from 'react-select/async';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { fetchData, updateData, postData } from '../../../apiService';
import DeleteIcon from '@mui/icons-material/Delete';
import { Button, Tooltip } from '@material-ui/core';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import SaveAsIcon from '@mui/icons-material/SaveAs';
import Modal from '@mui/material/Modal';
import { FaTimes } from 'react-icons/fa'; // Example for FontAwesome Icon
import AsyncCreatableSelect from 'react-select/async-creatable';
import { useLocation } from 'react-router-dom';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const PurchaseCreate = () => {
    const { id } = useParams(); // Use useParams to get the id from the URL  
    const [selectedItems, setSelectedItems] = useState([]);
    const [orderDetails, setOrderDetails] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const { isAuthenticated, companyId, branchId, userId, permissions, token, logout, branchstate } = useAuth();
    const [formData, setFormData] = useState([]);
    const [errorMessage, setErrorMessage] = useState("");
    const history = useHistory();
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [selectedSalesMan, setSelectedSalesMan] = useState("");
    const [dropdownSalesManOptions, setDropdownSalesManOptions] = useState([]);
    const location = useLocation();

    useEffect(() => {
        // Check if reload is needed based on the flag set in localStorage
        const shouldReload = localStorage.getItem('shouldReloadCreatePage') === 'true';

        if (shouldReload) {
            localStorage.removeItem('shouldReloadCreatePage'); // Remove the flag after use
            window.location.reload(); // Reload the page once
        }

        // Authentication and token expiration handling
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

        // Other initializations, if any
    }, [isAuthenticated, companyId, branchId, userId, token, logout]);

    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;

        return formattedDate;
    };

    useEffect(() => {
        fetchInvoicetypeData();
        fetchfrightrate();
    }, []);

    const [defaultFreightGSTRate, setdefaultFreightGSTRate] = useState(0);
    const [defaultPackingGSTRate, setdefaultPackingGSTRate] = useState(0);

    const fetchfrightrate = () => {
        fetchData('CompanyApi', `/${companyId}`, token)
            .then((response) => response.response_data)
            .then((data) => {

                setFormData(prevData => ({
                    ...prevData,
                    FreightGSTRate: data[0].FreightGSTRate,
                    PackingGSTRate: data[0].FreightGSTRate,
                }));
                setdefaultFreightGSTRate(data[0].FreightGSTRate);
                setdefaultPackingGSTRate(data[0].FreightGSTRate);
            })
            .catch((error) => {
                console.error('Error fetching options:', error);
            });
    };

    //FOR GET InvoicetypeData  Details FROM API
    const fetchInvoicetypeData = () => {
        fetchData('PurchaseApi', `/InvoiceType/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownInvoiceTypeOptions(data);

                const currentDate = new Date();
                const year = currentDate.getFullYear();
                const month = String(currentDate.getMonth() + 1).padStart(2, '0');
                const day = String(currentDate.getDate()).padStart(2, '0');
                const formattedDate = `${year}-${month}-${day}`;

                setFormData(prevData => ({
                    ...prevData,
                    BillDate: formattedDate,
                    ClearingDate: formattedDate,
                    BranchId: branchId,
                    CompanyId: companyId,
                    CreatedBy: userId,
                }));
            })
            .catch((error) => {
                console.error('Error fetching Disc Type dropdown options:', error);
            });
    };

    const [supplierOptions, setSupplierOptions] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [selectedInvoiceType, setSelectedInvoiceType] = useState(null);
    const [dropdownInvoiceTypeOptions, setDropdownInvoiceTypeOptions] = useState([]);
    const handleInputChange = (newValue) => newValue;

    const fetchOptions = async (inputValue) => {
        if (inputValue.length <= 2) {
            return [];
        }

        try {
            const response = await fetchData('PurchaseApi', `/Party/${companyId}/${companyId}/${inputValue}`, token);
            if (response.responseCode === '1111') {
                const data = await response.response_data;

                if (Array.isArray(data)) {
                    setSupplierOptions(data); // Save the options for later use
                    return data.map(item => ({
                        value: item.Id,
                        label: item.Name,
                    }));
                } else {
                    console.error('Data is not an array:', data);
                    return [];
                }
            } else {
                console.error('Unexpected response code:', response.responseCode);
                return [];
            }
        } catch (error) {
            console.error('Error fetching options:', error);
            return [];
        }
    };

    const handleCustomerSelect = (selectedOption) => {
        setSelectedOption(selectedOption);
        setFormData((prevData) => ({
            ...prevData,
            MasterId: selectedOption ? selectedOption.value : '',
            CreatedBy: userId,
        }));

        if (!selectedOption) return;

        const selectedItemId = selectedOption.value;
        const selectedSupplierRetail = supplierOptions.find((itemDetail) => itemDetail.Id === selectedItemId);
        const suppliergstno = selectedSupplierRetail?.GSTNumber ?? '';
        const supplieraddress1 = (selectedSupplierRetail?.AddressLine1 ?? '');
        const supplieraddress2 = (selectedSupplierRetail?.AddressLine2 ?? '');

        let invoiceTypeId = 2; // Default to B To C
        let gstNumber = '';

        if (!suppliergstno) {
            gstNumber = '';
            invoiceTypeId = 2;
        } else {
            const gstNumberPrefix = suppliergstno.substring(0, 2);
            if (gstNumberPrefix !== branchstate) {
                invoiceTypeId = 3; // IGST
                gstNumber = suppliergstno;
            } else {
                invoiceTypeId = 1; // B To B
                gstNumber = suppliergstno;
            }
        }

        setSelectedInvoiceType({
            value: invoiceTypeId,
            label: invoiceTypeId === 2 ? 'B To C' : invoiceTypeId === 3 ? 'IGST' : 'B To B',
        });

        setFormData((prevData) => ({
            ...prevData,
            InvoiceTypeId: invoiceTypeId,
            GSTNumber: gstNumber,
            CustomerAddress: supplieraddress1 + ' ' + supplieraddress2,
            CreatedBy: userId,
        }));
    };

    // Helper function to parse and handle NaN values as 0
    const parseAndFix = (val) => parseFloat(val) || 0;

    const calculateItemData = (item, formData) => {
        let rate = parseAndFix(item.Rate);
        let quantity = parseAndFix(item.Quantity);
        let cgstRate = parseAndFix(item.GSTRate) / 2;
        let sgstRate = parseAndFix(item.GSTRate) / 2;
        let Discper = parseAndFix(item.DiscountPercentage);
        let Addidiscamt = ((rate * Discper) / 100).toFixed(2)
        let totdiscount = parseFloat(Addidiscamt);
        let grate = (rate - totdiscount).toFixed(2);
        let amt = (quantity * rate).toFixed(2);
        let amount = (quantity * grate).toFixed(2);
        let cgstAmount = 0, sgstAmount = 0, igstAmount = 0;

        if (formData.InvoiceTypeId === 3) {
            igstAmount = ((amount * (cgstRate + sgstRate)) / 100).toFixed(2);
        } else {
            cgstAmount = ((amount * cgstRate) / 100).toFixed(2);
            sgstAmount = ((amount * sgstRate) / 100).toFixed(2);
        }

        let defaultFreightGST = Math.max(defaultFreightGSTRate, item.GSTRate);
        let defaultPackingGST = Math.max(defaultPackingGSTRate, item.GSTRate);
        setdefaultFreightGSTRate(defaultFreightGST);
        setdefaultPackingGSTRate(defaultPackingGST);

        const totalAmount = parseAndFix(amount) + parseAndFix(cgstAmount) + parseAndFix(sgstAmount) + parseAndFix(igstAmount);

        return {
            ...item,
            Amount: amt,
            DiscountAmount: parseAndFix(totdiscount * quantity).toFixed(2),
            TaxableAmount: amount,
            CGSTAmount: cgstAmount,
            SGSTAmount: sgstAmount,
            IGSTAmount: igstAmount,
            TotalAmount: totalAmount.toFixed(2),
        };
    };

    const totalCalculation = (Quantity, Amount, DiscountAmount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, FreightAmount, PackingAmount, TCSAmount, CashAmount, CardAmount, UPIAmount) => {

        let freightGSTRate = parseAndFix(formData.FreightGSTRate);
        let packingGSTRate = parseAndFix(formData.PackingGSTRate);
        freightGSTRate = Math.max(freightGSTRate, parseAndFix(defaultFreightGSTRate));
        packingGSTRate = Math.max(packingGSTRate, parseAndFix(defaultFreightGSTRate));

        let freightGSTAmount = ((FreightAmount * freightGSTRate) / 100).toFixed(2);
        let packingGSTAmount = ((PackingAmount * packingGSTRate) / 100).toFixed(2);

        let netAmount = parseAndFix(TaxableAmount) + parseAndFix(CGSTAmount) + parseAndFix(SGSTAmount) + parseAndFix(IGSTAmount) + parseAndFix(FreightAmount) + parseAndFix(PackingAmount) + parseAndFix(freightGSTAmount) + parseAndFix(packingGSTAmount) + parseAndFix(TCSAmount);
        let roundOff = Math.round(netAmount) - netAmount;
        let grandTotal = netAmount + roundOff;
        let balhamt = parseFloat(grandTotal - (parseAndFix(CashAmount) + parseAndFix(CardAmount) + parseAndFix(UPIAmount)));

        setFormData((prev) => ({
            ...prev,
            TotalQuantity: Quantity,
            Amount: Amount.toFixed(2),
            TaxableAmount: TaxableAmount.toFixed(2),
            CGSTAmount: CGSTAmount.toFixed(2),
            SGSTAmount: SGSTAmount.toFixed(2),
            IGSTAmount: IGSTAmount.toFixed(2),
            RoundOff: roundOff.toFixed(2),
            TotalAmount: grandTotal.toFixed(2),
            BalanceAmount: balhamt.toFixed(2),
            DiscountAmount: DiscountAmount.toFixed(2),
            FreightGSTAmount: freightGSTAmount,
            PackingGSTAmount: packingGSTAmount,
            ModifiedBy: userId,
            FreightGSTRate: freightGSTRate,
            PackingGSTRate: packingGSTRate,
        }));
    };

    // Calculation
    const handleCalculation = (e, index, inputType) => {
        let name, value;
        if (typeof e === 'object') {
            name = e.target.name;
            value = e.target.value;
        } else {
            name = inputType;
            value = e;
        }

        // Assuming selectedItems is a state setter function (e.g., setSelectedItems)
        setSelectedItems((prevDetails) => {

            const updatedDetails = [...prevDetails];
            const currentItem = { ...updatedDetails[index], [name]: value };

            // Update the item in the copied array
            updatedDetails[index] = currentItem;

            const updatedItemData = updatedDetails.map((item) => calculateItemData(item, formData));

            const totals = updatedItemData.reduce(
                (acc, item) => {
                    acc.Quantity += parseAndFix(item.Quantity);
                    acc.Amount += parseAndFix(item.Amount);
                    acc.DiscountAmount += parseAndFix(item.DiscountAmount);
                    acc.TaxableAmount += parseAndFix(item.TaxableAmount);
                    acc.CGSTAmount += parseAndFix(item.CGSTAmount);
                    acc.SGSTAmount += parseAndFix(item.SGSTAmount);
                    acc.IGSTAmount += parseAndFix(item.IGSTAmount);
                    acc.TotalAmount += parseAndFix(item.TotalAmount);

                    return acc;
                },
                { Quantity: 0, Amount: 0, DiscountAmount: 0, TaxableAmount: 0, CGSTAmount: 0, SGSTAmount: 0, IGSTAmount: 0, TotalAmount: 0 }
            );

            const FreightAmount = parseAndFix(formData.FreightAmount);
            const PackingAmount = parseAndFix(formData.PackingAmount);
            const TCSAmount = parseAndFix(formData.TCSAmount);
            let CashAmount = parseAndFix(formData.PaidAmount) || 0;
            let CardAmount = parseAndFix(formData.CardAmount) || 0;
            let UPIAmount = parseAndFix(formData.UPIAmount) || 0;

            totalCalculation(
                totals.Quantity,
                totals.Amount,
                totals.DiscountAmount,
                totals.TaxableAmount,
                totals.CGSTAmount,
                totals.SGSTAmount,
                totals.IGSTAmount,
                totals.TotalAmount,
                FreightAmount,
                PackingAmount,
                TCSAmount,
                CashAmount,
                CardAmount,
                UPIAmount,
            );

            return updatedItemData;
        });
    };

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;

        // Immediate update of the input field
        const updatedValue = type === 'checkbox' ? checked : (value === "" ? "0" : value);

        setFormData((prevData) => ({
            ...prevData,
            [name]: updatedValue,
        }));

        if (['FreightAmount', 'PackingAmount', 'TCSAmount', 'PaidAmount', 'CardAmount', 'UPIAmount'].includes(name)) {
            // Use the value directly for the calculation to avoid relying on stale state
            updateFormDataAndDetails(name, updatedValue);
        }
    };

    const updateFormDataAndDetails = (key, value) => {
        const fixedValue = parseAndFix(value).toFixed(2);

        // Update the formData with the new value
        setFormData((prevData) => ({
            ...prevData,
            [key]: fixedValue,
            ModifiedBy: userId,
        }));

        // Use the updated value for calculations
        const updatedFormData = {
            ...formData,    // current form data
            [key]: fixedValue  // the newly updated value
        };

        // Recalculate invoice details using the latest form data
        const updatedItemData = selectedItems.map((item) => calculateItemData(item, updatedFormData));
        setSelectedItems(updatedItemData);

        // Calculate totals based on the updated invoice details
        const totals = calculateTotals(updatedItemData);

        // Dynamically get the values from the updated form data
        const dynamicValue = (key) => parseAndFix(updatedFormData[key] || 0);

        // Fetch the latest values for calculations               
        const TCSAmount = dynamicValue('TCSAmount');
        const FreightAmount = dynamicValue('FreightAmount');
        const PackingAmount = dynamicValue('PackingAmount');
        let CashAmount = dynamicValue('PaidAmount');
        let CardAmount = dynamicValue('CardAmount');
        let UPIAmount = dynamicValue('UPIAmount');
        // Perform the final total calculation
        totalCalculation(
            totals.Quantity,
            totals.Amount,
            totals.DiscountAmount,
            totals.TaxableAmount,
            totals.CGSTAmount,
            totals.SGSTAmount,
            totals.IGSTAmount,
            totals.TotalAmount,
            FreightAmount,
            PackingAmount,
            TCSAmount,
            CashAmount,
            CardAmount,
            UPIAmount,
        );
    };

    // Utility function to calculate totals
    const calculateTotals = (updatedItemData) => {
        return updatedItemData.reduce(
            (acc, item) => {
                acc.Quantity += parseAndFix(item.Quantity);
                acc.Amount += parseAndFix(item.Amount);
                acc.TaxableAmount += parseAndFix(item.TaxableAmount);
                acc.DiscountAmount += parseAndFix(item.DiscountAmount);
                acc.CGSTAmount += parseAndFix(item.CGSTAmount);
                acc.SGSTAmount += parseAndFix(item.SGSTAmount);
                acc.IGSTAmount += parseAndFix(item.IGSTAmount);
                acc.TotalAmount += parseAndFix(item.TotalAmount);
                return acc;
            },
            { Quantity: 0, Amount: 0, TaxableAmount: 0, DiscountAmount: 0, CGSTAmount: 0, SGSTAmount: 0, IGSTAmount: 0, TotalAmount: 0, CESSAmount: 0 }
        );
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsLoading(true);

        if (!formData.BillNumber) {
            setErrorMessage('Bill Number is required !');
            setIsLoading(false);
            return;
        }

        if (!formData.MasterId) {
            setErrorMessage('Supplier is required !');
            setIsLoading(false);
            return;
        }

        setFormData(prevData => ({
            ...prevData,
            CreatedBy: userId,
            BranchId: branchId,
            CompanyId: companyId,
        }));

        const PurchaseVM = {
            Purchase: formData,
            PurchaseDetails: selectedItems
        };

        // Validate form data here if needed
        postData('PurchaseApi', PurchaseVM, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                history.push('/PurchaseIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
            });
    };

    //handle search [ITEM SEARCH]
    const [isFocused, setIsFocused] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const filteredData = selectedItems.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const [itemToDeleteIndex, setItemToDeleteIndex] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

    const openConfirmDialog = (index) => {
        setItemToDeleteIndex(index);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setConfirmDialogOpen(false);
        setItemToDeleteIndex(null);
    };

    const handleDelete = () => {
        if (itemToDeleteIndex !== null) {
            const updatedItemList = selectedItems.filter((_, i) => i !== itemToDeleteIndex);
            setSelectedItems(updatedItemList);

            const updatedItemData = updatedItemList.map((item) => calculateItemData(item, formData));

            const totals = updatedItemData.reduce(
                (acc, item) => {
                    acc.Quantity += parseAndFix(item.Quantity);
                    acc.Amount += parseAndFix(item.Amount);
                    acc.DiscountAmount += parseAndFix(item.DiscountAmount);
                    acc.TaxableAmount += parseAndFix(item.TaxableAmount);
                    acc.CGSTAmount += parseAndFix(item.CGSTAmount);
                    acc.SGSTAmount += parseAndFix(item.SGSTAmount);
                    acc.IGSTAmount += parseAndFix(item.IGSTAmount);
                    acc.TotalAmount += parseAndFix(item.TotalAmount);

                    return acc;
                },
                { Quantity: 0, Amount: 0, DiscountAmount: 0, TaxableAmount: 0, CGSTAmount: 0, SGSTAmount: 0, IGSTAmount: 0, TotalAmount: 0 }
            );

            const FreightAmount = parseAndFix(formData.FreightAmount);
            const PackingAmount = parseAndFix(formData.PackingAmount);
            const TCSAmount = parseAndFix(formData.TCSAmount);
            let CashAmount = parseAndFix(formData.PaidAmount) || 0;
            let CardAmount = parseAndFix(formData.CardAmount) || 0;
            let UPIAmount = parseAndFix(formData.UPIAmount) || 0;

            totalCalculation(
                totals.Quantity,
                totals.Amount,
                totals.DiscountAmount,
                totals.TaxableAmount,
                totals.CGSTAmount,
                totals.SGSTAmount,
                totals.IGSTAmount,
                totals.TotalAmount,
                FreightAmount,
                PackingAmount,
                TCSAmount,
                CashAmount,
                CardAmount,
                UPIAmount,
            );

            closeConfirmDialog();
        }

    };

    const [itemsOptions, setItemsrOptions] = useState([]);
    const handleItemChange = (newValue) => newValue;
    const fetchItemOptions = async (inputValue = '') => {
        // Early return if input value is empty or too short
        if (!inputValue || inputValue.length <= 1) {
            return [];
        }

        const customerid = formData.MasterId;
        try {
            // Fetch data from the API
            const response = await fetchData('PurchaseApi', `/Item/${companyId}/${companyId}/${inputValue}`, token);

            // Check if the response code is 1111
            if (response.responseCode === '1111') {
                const data = await response.response_data;

                // Ensure the response data is an array
                if (Array.isArray(data)) {
                    setItemsrOptions(data); // Save the options for later use
                    return data.map(item => ({
                        value: item.Id,
                        label: item.ItemName1,
                    }));
                } else {
                    console.error('Data is not an array:', data);
                    return [];
                }
            } else {
                console.error('Unexpected response code:', response.responseCode);
                return [];
            }
        } catch (error) {
            console.error('Error fetching item options:', error);
            return [];
        }
    };

    const handleChangeDrop = (selectedOption) => {
        setSelectedItemOption(selectedOption);

        const selectedItemId = selectedOption ? selectedOption.value : '';
        const selectedItemDetail = itemsOptions.find((itemDetail) => itemDetail.Id === selectedItemId);

        if (selectedItemDetail) {

            // const quantity = parseFloat(modalData.Quantity) || 0;
            const quantity = '1';
            const rate = parseFloat(selectedItemDetail.PurchaseRate.toFixed(2)) || 0;
            const cgstrate = parseFloat((selectedItemDetail.GSTRate / 2).toFixed(2)) || 0;
            const sgstrate = parseFloat((selectedItemDetail.GSTRate / 2).toFixed(2)) || 0;
            const amount = (quantity * rate).toFixed(2);
            let cgstamt = 0;
            let sgstamt = 0;
            let igstamt = 0;
            let gstrate = (cgstrate + sgstrate).toFixed(2);
            if (formData.InvoiceTypeId == 3) {
                igstamt = ((amount * (cgstrate + sgstrate)) / 100).toFixed(2);
            }
            else {
                cgstamt = ((amount * (cgstrate)) / 100).toFixed(2);
                sgstamt = ((amount * (sgstrate)) / 100).toFixed(2);
            }
            let gstamt = parseFloat((cgstamt + sgstamt + igstamt)).toFixed(2);
            const totalAmount = (parseFloat(amount) + parseFloat(cgstamt) + parseFloat(sgstamt) + parseFloat(igstamt)).toFixed(2);

            let defaultFreightGST = Math.max(defaultFreightGSTRate, gstrate);
            let defaultPackingGST = Math.max(defaultPackingGSTRate, gstrate);
            setdefaultFreightGSTRate(defaultFreightGST);
            setdefaultPackingGSTRate(defaultPackingGST);

            setModalData({
                ...modalData,
                Rate: rate, //selectedItemDetail.PurchaseRate.toFixed(2), // Assuming Rate is a number
                GSTRate: gstrate,
                ItemName: selectedOption ? selectedItemDetail.ItemName : '',
                ItemName1: selectedOption ? selectedItemDetail.ItemName1 : '',
                HSNCode: selectedOption ? selectedItemDetail.HSNCode : '',
                ItemId: selectedOption ? selectedOption.value : '',
                TaxableAmount: amount,
                Amount: amount,
                CGSTAmount: cgstamt,
                SGSTAmount: sgstamt,
                IGSTAmount: igstamt,
                TotalAmount: totalAmount,
                GSTAmt: gstamt,
                Quantity: quantity,
            });

        } else {
            // Handle the case where the item detail is not found
            setModalData({
                ...modalData,
                Rate: '',
                GSTRate: '0.00',
                ItemName: '',
                ItemName1: '',
                ItemId: '',
                TaxableAmount: '0.00',
                CGSTAmount: '0.00',
                SGSTAmount: '0.00',
                IGSTAmount: '0.00',
                TotalAmount: '0.00',
                GSTAmt: '0.00',
                Quantity: '',
            });
        }
    };

    const handleModalInputChange = (event) => {
        const { name, value } = event.target;

        // Prevent negative quantity
        if (name === 'Quantity' && parseFloat(value) < 0) {
            alert('Quantity cannot be negative');
            return;
        }

        setModalData((prevData) => ({
            ...prevData,
            [name]: value,
        }));

        if (name === 'Quantity') {
            const quantity = parseFloat(value) || 0;
            const rate = parseFloat(modalData.Rate) || 0;
            const gstRate = parseFloat(modalData.GSTRate) || 0;
            const cgstrate = gstRate / 2;
            const sgstrate = gstRate / 2;

            const amount = (quantity * rate).toFixed(2);
            let cgstamt = 0;
            let sgstamt = 0;
            let igstamt = 0;

            if (formData.InvoiceTypeId === 3) {
                igstamt = ((amount * (cgstrate + sgstrate)) / 100).toFixed(2);
            } else {
                cgstamt = ((amount * cgstrate) / 100).toFixed(2);
                sgstamt = ((amount * sgstrate) / 100).toFixed(2);
            }

            const gstamt = (
                parseFloat(cgstamt) + parseFloat(sgstamt) + parseFloat(igstamt)
            ).toFixed(2);

            const totalAmount = (
                parseFloat(amount) + parseFloat(gstamt)
            ).toFixed(2);

            const defaultFreightGST = Math.max(defaultFreightGSTRate, gstRate);
            const defaultPackingGST = Math.max(defaultPackingGSTRate, gstRate);

            setdefaultFreightGSTRate(defaultFreightGST);
            setdefaultPackingGSTRate(defaultPackingGST);

            setModalData((prevData) => ({
                ...prevData,
                Rate: rate,
                Quantity: quantity,
                Amount: amount,
                TaxableAmount: amount,
                CGSTAmount: cgstamt,
                SGSTAmount: sgstamt,
                IGSTAmount: igstamt,
                TotalAmount: totalAmount,
                GSTAmt: gstamt,
            }));
        }

        else if (name === 'Rate') {
            const quantity = parseFloat(modalData.Quantity) || 0;
            const rate = parseFloat(value) || 0;
            const gstRate = parseFloat(modalData.GSTRate) || 0;
            const cgstrate = gstRate / 2;
            const sgstrate = gstRate / 2;

            const amount = (quantity * rate).toFixed(2);
            let cgstamt = 0;
            let sgstamt = 0;
            let igstamt = 0;

            if (formData.InvoiceTypeId === 3) {
                igstamt = ((amount * (cgstrate + sgstrate)) / 100).toFixed(2);
            } else {
                cgstamt = ((amount * cgstrate) / 100).toFixed(2);
                sgstamt = ((amount * sgstrate) / 100).toFixed(2);
            }

            const gstamt = (
                parseFloat(cgstamt) + parseFloat(sgstamt) + parseFloat(igstamt)
            ).toFixed(2);

            const totalAmount = (
                parseFloat(amount) + parseFloat(gstamt)
            ).toFixed(2);

            const defaultFreightGST = Math.max(defaultFreightGSTRate, gstRate);
            const defaultPackingGST = Math.max(defaultPackingGSTRate, gstRate);

            setdefaultFreightGSTRate(defaultFreightGST);
            setdefaultPackingGSTRate(defaultPackingGST);

            setModalData((prevData) => ({
                ...prevData,
                Rate: rate,
                Quantity: quantity,
                Amount: amount,
                TaxableAmount: amount,
                CGSTAmount: cgstamt,
                SGSTAmount: sgstamt,
                IGSTAmount: igstamt,
                TotalAmount: totalAmount,
                GSTAmt: gstamt,
            }));
        }
    };

    //// modalData 
    // FOR MODEL DATA (Invoice Details)
    const [selectedItemOption, setSelectedItemOption] = useState(null);

    const [modalData, setModalData] = useState({
        SlNo: '0',
        ItemName: '',
        ItemName1: '',
        ItemId: '',
        Quantity: '',
        Rate: '',
        Amount: '',
        TaxableAmount: '',
        GSTRate: '',
        GSTAmount: '',
        TotalAmount: '',
        BalanceStock: '0',
    });

    const closeModal = () => {
        setModalData({
            SlNo: '0',
            ItemName: '',
            ItemName1: '',
            ItemId: '',
            Quantity: '',
            Rate: '',
            Amount: '',
            GSTRate: '',
            GSTAmount: '',
            TotalAmount: '',
            BalanceStock: '0',
        });
    };    

    const saveModalData = () => {
        let isValid = true;
        let errors = "";
        setErrorMessageModel(errors);

        // Validation for ItemId
        if (!modalData.ItemId) {
            isValid = false;
            errors = "Item is required";
        }

        // Validation for Quantity
        if (!modalData.Quantity || isNaN(modalData.Quantity)) {
            isValid = false;
            errors = "Quantity must be a valid number";
        }

        // Prevent duplicate item with same rate
        const duplicateExists = selectedItems.some(
            item => item.ItemId === modalData.ItemId && parseFloat(item.Rate) === parseFloat(modalData.Rate)
        );

        if (duplicateExists) {
            setErrorMessageModel("This item with the same rate is already added.");
            return;
        }

        if (isValid) {
            // ✅ Sanitize numeric fields before pushing
            const sanitizedModalData = {
                ...modalData,
                Quantity: parseFloat(modalData.Quantity) || 0,
                Rate: parseFloat(modalData.Rate) || 0,
                Amount: parseFloat(modalData.Amount) || 0,
                GSTRate: parseFloat(modalData.GSTRate) || 0,
                GSTAmount: parseFloat(modalData.GSTAmount) || 0,
                CGSTAmount: parseFloat(modalData.CGSTAmount) || 0,
                SGSTAmount: parseFloat(modalData.SGSTAmount) || 0,
                IGSTAmount: parseFloat(modalData.IGSTAmount) || 0,
                TotalAmount: parseFloat(modalData.TotalAmount) || 0,
                BalanceStock: parseFloat(modalData.BalanceStock) || 0,
                TaxableAmount: parseFloat(modalData.TaxableAmount) || 0,
            };

            const updatedInvoicedetails = [...selectedItems, sanitizedModalData];
            const updatedInvoicedetailsSorted = updatedInvoicedetails.reverse();
            const updatedItemData = updatedInvoicedetailsSorted.map((item) => calculateItemData(item, formData));

            setSelectedItems(updatedItemData);

            // ✅ Reset with numbers where applicable
            setModalData({
                SlNo: 0,
                ItemName: '',
                ItemName1: '',
                ItemId: '',
                Quantity: 0,
                Rate: 0,
                Amount: 0,
                GSTRate: 0,
                GSTAmount: 0,
                CGSTAmount: 0,
                SGSTAmount: 0,
                IGSTAmount: 0,
                TaxableAmount: 0,
                TotalAmount: 0,
                BalanceStock: 0,
            });

            setSelectedItemOption(null); // Clear AsyncSelect
            fetchItemOptions('');

            //Update the totals based on the updatedItemData
            const Quantity = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            const Amount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const CGSTAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const SGSTAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            const IGSTAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
            const TotalAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);
            const TaxableAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);

            let FreightAmount = parseFloat(formData.FreightAmount) || 0;
            let PackingAmount = parseFloat(formData.PackingAmount) || 0;
            let TCSAmount = parseFloat(formData.TCSAmount) || 0;
            let DiscountAmount = parseFloat(formData.DiscountAmount) || 0;
            let CashAmount = parseAndFix(formData.PaidAmount) || 0;
            let CardAmount = parseAndFix(formData.CardAmount) || 0;
            let UPIAmount = parseAndFix(formData.UPIAmount) || 0;

            totalCalculation(
                Quantity, Amount, DiscountAmount, TaxableAmount,
                CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount,
                FreightAmount, PackingAmount, TCSAmount, CashAmount,
                CardAmount, UPIAmount
            );

        } else {
            console.log("Validation errors:", errors);
            // setErrorMessageModel(errors);
        }
    };

    const [showModal, setShowModal] = useState(false);

    const opendatamodal = () => {
        setShowModal(true);
    };

    const closeDataModal = () => {
        console.log('Closing modal');
        setShowModal(false);
    };

    return (
        <div className="w-full max-w-sm container mt-6 mx-auto" style={{ minWidth: '100%', marginTop: '-10px' }}>

            <div className="flex flex-wrap justify-between items-center mb-4">
                <h6
                    className="uppercase tracking-wide text-black font-serif flex-grow"
                    style={{
                        fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif',
                        color: 'black',
                        marginTop: '10px',
                    }}
                >
                    Purchase Create
                </h6>
                <Modal open={confirmDialogOpen} onClose={closeConfirmDialog} style={{ marginTop: '10%' }}>
                    <div style={{ padding: '20px', backgroundColor: 'white', borderRadius: '8px', margin: 'auto', width: '30%', textAlign: 'center' }}>
                        <h5>Confirm Delete</h5>
                        <p>Are you sure you want to delete this item? 🤕</p>
                        <Button style={{ margin: '8px', color: 'red' }} onClick={handleDelete}>Delete</Button>
                        <Button style={{ margin: '8px', color: 'grey' }} onClick={closeConfirmDialog}>Cancel</Button>
                    </div>
                </Modal>

                <div className="flex items-center w-full sm:w-auto sm:ml-4" style={{ marginRight: '120px', marginTop: '20px' }}>
                    <div className="mr-4">
                        <input
                            className="shadow text-gray-700 leading-tight"
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                            onFocus={() => setIsFocused(true)}
                            onBlur={() => setIsFocused(false)}
                            style={{
                                width: isFocused ? '200px' : '170px',
                                height: '30px',
                                border: '1px solid #ccc',
                                borderRadius: '15px',
                                padding: '0 20px',
                                transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                                outline: 'none',
                                borderColor: isFocused ? 'darkcyan' : '#ccc',
                                boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                            }}
                        />
                    </div>

                    <div className="mr-4">
                        <label className="uppercase tracking-wide text-black text-xs font-bold" htmlFor="billDate" style={{ fontSize: '12px', fontFamily: 'monospace' }}>
                            Total Item Count :
                            <span style={{ color: '#F2613F', fontSize: '14px', marginLeft: '4px' }}>
                                {selectedItems.length}
                            </span>
                        </label>
                    </div>

                    <div>
                        <label className="uppercase tracking-wide text-black text-xs font-bold" htmlFor="totalQuantity" style={{ fontSize: '12px', fontFamily: 'monospace' }}>
                            Total QTY :
                            <span style={{ color: 'green', fontSize: '14px', marginLeft: '4px' }}>
                                {formData.TotalQuantity}
                            </span>
                        </label>
                    </div>
                </div>

                <div className="flex mt-8 w-full sm:w-auto">
                    <Button
                        style={{ marginLeft: '8px', color: 'darkgreen' }}
                        onClick={handleSubmit}
                        disabled={isLoading}
                    >
                        <CheckCircleOutlineIcon style={{ color: 'darkgreen', fontWeight: 'bolder' }} />
                        {isLoading ? <CircularProgress size={24} color="inherit" /> : <b>SAVE</b>}
                    </Button>
                    <Button
                        color="error"
                        component={Link}
                        to="/Home"
                        className="linkcolor"
                        style={{ marginLeft: '8px', color: 'darkred', fontWeight: 'bolder' }}
                    >
                        <ArrowCircleLeftIcon style={{ color: 'darkred', fontWeight: 'bolder' }} /> Back To List
                    </Button>
                </div>
            </div>

            {errorMessage && <p className="text-red-500">{errorMessage}</p>}
            <div className="w-full flex flex-wrap" style={{ padding: '7px', borderRadius: '10px', marginTop: '-2.50%' }}>

                <div className="w-full pr-4" style={{ marginTop: '1%' }}>
                    <div className="w-full mb-2 flex">

                        <div className="w-4/5 mr-2" style={{ marginTop: '-5px' }}>
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="supplierName" style={{ fontSize: '12px', fontFamily: 'monospace' }}>
                                Supplier Name
                                <span className="text-red-500">*</span>
                                <span style={{ marginLeft: '10%', color: 'black', fontFamily: 'monospace' }}> Invoice Type : </span> <span style={{ color: 'black', fontSize: '14px', fontWeight: 'bolder', fontFamily: 'monospace' }}>{selectedInvoiceType ? selectedInvoiceType.label : ''}</span>                            </label>
                            <AsyncCreatableSelect
                                cacheOptions
                                loadOptions={fetchOptions}
                                onInputChange={handleInputChange}
                                onChange={handleCustomerSelect}
                                value={selectedOption}
                                placeholder="Type or select a Supplier"
                                formatCreateLabel={(inputValue) => `Add "${inputValue}"`}
                                isClearable
                                onCreateOption={(inputValue) => {
                                    const newOption = { value: inputValue, label: inputValue };
                                    setSupplierOptions([...supplierOptions, newOption]);
                                    setSelectedOption(newOption);
                                    setFormData((prevData) => ({
                                        ...prevData,
                                        MasterId: 0,
                                        CreatedBy: userId,
                                        CustomerName: inputValue,
                                        CustomerAddress: '',
                                        GSTNumber: '',
                                        ContactNumber: '',
                                        InvoiceTypeId: 2,
                                    }));
                                    const newInvoiceTypeId = 2;
                                    setSelectedInvoiceType({
                                        value: 2,
                                        label: 'B To C'
                                    });
                                }}
                                styles={{
                                    control: (provided) => ({
                                        ...provided,
                                        minHeight: '30px',
                                        height: '30px',
                                        marginTop: '5px',
                                    }),
                                    valueContainer: (provided) => ({
                                        ...provided,
                                        height: '30px',
                                        padding: '0 6px',
                                    }),
                                    input: (provided) => ({
                                        ...provided,
                                        margin: 0,
                                        padding: 0,
                                    }),
                                    indicatorsContainer: (provided) => ({
                                        ...provided,
                                        height: '30px',
                                    }),
                                    menuPortal: (provided) => ({
                                        ...provided,
                                        zIndex: 9999, // Ensures dropdown is above everything
                                    }),
                                }}
                                menuPortalTarget={document.body} // Required for zIndex to work
                            />
                        </div>


                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billDate" style={{ fontSize: '12px', fontFamily: 'monospace' }}>
                                Bill Date
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                value={formatDateForInput(formData.BillDate)}
                                onChange={handleChange}
                                type="date"
                                name='BillDate'

                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billNumber" style={{ fontSize: '12px', fontFamily: 'monospace' }}>
                                Bill Number
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                value={formData.BillNumber}
                                onChange={handleChange}
                                type="text"
                                placeholder="Bill Number"
                                name='BillNumber'
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billDate" style={{ fontSize: '12px', fontFamily: 'monospace' }}>
                                Clearing Date
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                value={formatDateForInput(formData.ClearingDate)}
                                onChange={handleChange}
                                type="date"
                                name='ClearingDate'
                            />
                        </div>

                    </div>
                    <div className="w-full mb-2 flex" style={{ fontWeight: '13px' }}>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ fontSize: '12px', fontFamily: 'monospace' }}>
                                Amount :<span style={{ color: 'red', fontSize: '14px' }}>{formData.Amount}</span>
                            </label>
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ fontSize: '12px', fontFamily: 'monospace' }}>
                                Discount : <span style={{ color: 'red', fontSize: '14px' }}>{formData.DiscountAmount}</span>
                            </label>
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ fontSize: '12px', fontFamily: 'monospace' }}>
                                Taxable : <span style={{ color: 'red', fontSize: '14px' }}>{formData.TaxableAmount}</span>
                            </label>
                        </div>
                        {formData.CGSTAmount > 0 && (
                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ fontSize: '12px', fontFamily: 'monospace' }}>
                                    CGST :<span style={{ color: 'red', fontSize: '14px' }}>{formData.CGSTAmount}</span>
                                </label>
                            </div>
                        )}
                        {formData.SGSTAmount > 0 && (
                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ fontSize: '12px', fontFamily: 'monospace' }}>
                                    SGST :<span style={{ color: 'red', fontSize: '14px' }}>{formData.SGSTAmount}</span>
                                </label>
                            </div>
                        )}
                        {formData.IGSTAmount > 0 && (
                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ fontSize: '12px', fontFamily: 'monospace' }}>
                                    IGST :<span style={{ color: 'red', fontSize: '14px' }}>{formData.IGSTAmount}</span>
                                </label>
                            </div>
                        )}
                        <div className="w-1/2 mr-2">
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                type="text"
                                placeholder="Enter Remarks"
                                name="Remarks"
                                value={formData.Remarks}
                                onChange={handleChange}
                            />
                        </div>
                    </div>
                    <div className="w-full mb-2 flex">

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ fontSize: '12px', fontFamily: 'monospace' }}>
                                Freight <span style={{ color: 'darkmagenta' }}>({formData.FreightGSTRate}%)</span> <span style={{ color: 'red' }}>{formData.FreightGSTAmount}</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                value={formData.FreightAmount}
                                type="text"
                                placeholder="FreightAmount"
                                style={{ textAlign: 'right' }}
                                name='FreightAmount'
                                onChange={handleChange}
                                min="0"
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ fontSize: '12px', fontFamily: 'monospace' }}>
                                Packing  <span style={{ color: 'darkmagenta' }}> ({formData.PackingGSTRate}%)</span> <span style={{ color: 'red' }}>{formData.PackingGSTAmount}</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                value={formData.PackingAmount}
                                type="text"
                                placeholder="PackingAmount"
                                style={{ textAlign: 'right' }}
                                name='PackingAmount'
                                onChange={handleChange}
                                min="0"
                            />
                        </div>

                        <div className="w-1/6 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ fontSize: '12px', fontFamily: 'monospace' }}>
                                TCS Amount
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                value={formData.TCSAmount}
                                type="number"
                                placeholder="TCS Amount"
                                style={{ textAlign: 'right' }}
                                name='TCSAmount'
                                onChange={handleChange}
                                min="0"
                            />
                        </div>

                        <div className="w-1/6 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ fontSize: '12px', fontFamily: 'monospace' }}>
                                Round Off
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                value={formData.RoundOff}
                                type="text"
                                placeholder="RoundOff"
                                style={{ textAlign: 'right' }}
                                name='RoundOff'
                                readOnly
                            />
                        </div>

                        <div className="w-1/6 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ fontSize: '12px', fontFamily: 'monospace' }}>
                                Grand Total
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                value={formData.TotalAmount}
                                type="text"
                                placeholder="TotalAmount"
                                style={{ textAlign: 'right' }}
                                name='TotalAmount'
                                readOnly
                            />
                        </div>

                        <div className="w-1/6 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ fontSize: '12px', fontFamily: 'monospace' }}>
                                Cash Amount
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                value={formData.PaidAmount}
                                type="number"
                                placeholder="PaidAmount"
                                style={{ textAlign: 'right' }}
                                name='PaidAmount'
                                onChange={handleChange}
                                max={formData.TotalAmount}
                                min="0"
                            />
                        </div>

                        <div className="w-1/6 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber" style={{ fontSize: '12px', fontFamily: 'monospace' }}>
                                Balance
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 leading-tight focus:shadow-outline h-8"
                                value={formData.BalanceAmount}
                                type="text"
                                placeholder="BalanceAmount"
                                style={{
                                    textAlign: 'right',
                                    color: formData.BalanceAmount > 0 ? 'red' : 'inherit' // Sets color to red if BlanceAmount > 0
                                }}
                                name='BalanceAmount'
                                readOnly
                            />
                        </div>

                    </div>

                    <div className="w-full mb-2 flex" style={{ marginTop: '15px' }}>

                        {/* Item Name */}
                        <div className="w-4/5 mr-2 flex items-center">
                            <label
                                className="block uppercase tracking-wide text-black text-xs font-bold mr-2"
                                htmlFor="Weightage" style={{ fontSize: '12px', fontFamily: 'monospace' }}
                            >
                                Item Name
                            </label>
                            <AsyncSelect
                                cacheOptions
                                loadOptions={fetchItemOptions}
                                onInputChange={handleItemChange}
                                onChange={handleChangeDrop}
                                value={selectedItemOption}
                                className="flex-grow"
                                styles={{
                                    control: (provided) => ({
                                        ...provided,
                                        minHeight: '30px',
                                        height: '30px',
                                        marginTop: '5px',
                                    }),
                                    valueContainer: (provided) => ({
                                        ...provided,
                                        height: '30px',
                                        padding: '0 6px',
                                    }),
                                    input: (provided) => ({
                                        ...provided,
                                        margin: 0,
                                        padding: 0,
                                    }),
                                    indicatorsContainer: (provided) => ({
                                        ...provided,
                                        height: '30px',
                                    }),
                                    menuPortal: (provided) => ({
                                        ...provided,
                                        zIndex: 9999, // Ensures dropdown is above everything
                                    }),
                                }}
                                menuPortalTarget={document.body} // Required for zIndex to work
                            />
                        </div>

                        {/* Quantity */}
                        <div className="w-1/4 mr-2 flex items-center">
                            <label
                                className="block uppercase tracking-wide text-black text-xs font-bold mr-2"
                                htmlFor="MinimumStock" style={{ fontSize: '12px', fontFamily: 'monospace' }}
                            >
                                Quantity
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right h-8"
                                type="number"
                                name="Quantity"
                                placeholder="Quantity"
                                value={modalData.Quantity}
                                onChange={handleModalInputChange}
                                min={0}
                            />
                        </div>

                        {/* Rate */}
                        <div className="w-1/5 mr-2 flex items-center">
                            <label
                                className="block uppercase tracking-wide text-black text-xs font-bold mr-2"
                                htmlFor="MinimumStock" style={{ fontSize: '12px', fontFamily: 'monospace' }}
                            >
                                Rate
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right h-8"
                                type="number"
                                name="Rate"
                                placeholder="Rate"
                                value={modalData.Rate}
                                onChange={handleModalInputChange}
                                onClick={(e) => e.target.select()}
                            />
                        </div>

                        {/* Add Button */}
                        <div className="w-2/5 mr-2">
                            <button
                                className="bg-green-500 hover:bg-green-600 text-white text-xs font-semibold px-3 py-1 rounded-full shadow-md transition duration-200"
                                onClick={saveModalData}
                                style={{ marginLeft: '10px', marginTop: '5px', width: '80px', height: '30px', cursor: 'pointer' }}
                            >
                                Add
                            </button>

                        </div>

                    </div>

                    <div className="w-full mb-2" style={{ marginTop: '-0.15%', overflow: 'auto' }}>
                        <table
                            className="min-w-full bg-white shadow-md rounded-lg overflow-hidden"
                            style={{
                                borderCollapse: 'collapse',
                                border: '1px solid #ddd',
                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                // background: 'linear-gradient(135deg, #F3F7FF, #FFFFFF)',
                                color: 'white'
                            }}
                        >
                            <thead
                                style={{
                                    // backgroundColor: '#C1D8C3',
                                    backgroundColor: '#27445D',
                                    color: 'white',
                                    textAlign: 'left',
                                    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',

                                }}
                            >
                                <tr>
                                    <th
                                        style={{
                                            fontSize: '13px',
                                            padding: '4px',
                                            borderBottom: '2px solid #E0E0E0',
                                            textAlign: 'left', // Align SL.No to the left
                                            color: 'white'
                                        }}
                                    >
                                        SL.No
                                    </th>
                                    {[
                                        // 'SL.No',
                                        'ITEM',
                                        'QTY',
                                        'RATE',
                                        'AMOUNT',
                                        'DIS %',
                                        'DIS ₹',
                                        'TAXABLE',
                                        'GST ₹',
                                        'TOTAL',
                                    ].map((header) => (
                                        <th
                                            key={header}
                                            style={{
                                                fontSize: '12px',
                                                padding: '4px',
                                                borderBottom: '2px solid #E0E0E0',
                                                textAlign: header === 'ITEM' ? 'left' : 'right',
                                                color: 'white',
                                                height: '12px',
                                                fontFamily: 'monospace'
                                            }}
                                        >
                                            {header}
                                        </th>
                                    ))}
                                </tr>
                            </thead>

                            <tbody>
                                {filteredData.map((item, index) => {
                                    return (
                                        <tr key={index} className="border-b"
                                            style={{
                                                backgroundColor: index % 2 === 0 ? '#F7FAFF' : '#FFFFFF',
                                                borderBottom: '1px solid #E0E0E0',
                                                transition: 'transform 0.2s ease-in-out',
                                                cursor: 'pointer',
                                                color: 'black'
                                            }}
                                            // onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.02)')}
                                            // onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                        >

                                            <td style={{ fontSize: '13px', fontWeight: 'bold', padding: '1px', textAlign: 'center', width: '75px' }}>
                                                {index + 1}
                                                <Tooltip
                                                    title="Delete Purchase Order"
                                                    componentsProps={{
                                                        tooltip: {
                                                            sx: {
                                                                backgroundColor: 'darkolivegreen',
                                                                color: 'white',
                                                                border: '1px solid white',
                                                                fontWeight: 'bold',
                                                                boxShadow: 2,
                                                                fontSize: '0.875rem',
                                                            },
                                                        },
                                                    }}
                                                >
                                                    <DeleteIcon
                                                        style={{ color: 'brown', cursor: 'pointer', marginLeft: '20px', marginTop: '-5px' }}
                                                        onClick={() => openConfirmDialog(index)}
                                                    />
                                                </Tooltip>
                                            </td>
                                            <td style={{ fontSize: '12px', fontWeight: 'bold', padding: '3px', width: '200px' }}>{item.ItemName}</td>

                                            <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                                <input
                                                    type="number"
                                                    value={item.Quantity}
                                                    className="w-full px-1 py-1 border rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-400"
                                                    style={{ fontSize: '13px', fontWeight: 'bold', backgroundColor: '#ECFAE5', textAlign: 'right' }}
                                                    min="0"
                                                    aria-label={`Order quantity for item ${item.Id}`}
                                                    name="Quantity"
                                                    onChange={(e) => handleCalculation(e, index, 'Quantity')}
                                                />
                                            </td>
                                            <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                                <input
                                                    value={item.Rate || 0}
                                                    onChange={(e) => handleCalculation(e, index, 'Rate')}
                                                    className="w-full px-1 py-1 border rounded-md"
                                                    style={{ fontSize: '13px', fontWeight: 'bold', backgroundColor: '#F6D6D6', textAlign: 'right' }}
                                                    type="number"
                                                    name="Rate"
                                                />
                                            </td>
                                            <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                                <input
                                                    value={item.Amount || 0}
                                                    className="w-full px-1 py-1 border rounded-md"
                                                    style={{ fontSize: '13px', fontWeight: 'bold', textAlign: 'right' }}
                                                    name="Amount"
                                                    readOnly
                                                />
                                            </td>
                                            <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                                <input
                                                    value={item.DiscountPercentage || 0}
                                                    onChange={(e) => handleCalculation(e, index, 'DiscountPercentage')}
                                                    className="w-full px-1 py-1 border rounded-md"
                                                    style={{ fontSize: '13px', fontWeight: 'bold', backgroundColor: '#F2EFE7', textAlign: 'right' }}
                                                    type="number"
                                                    name="DiscountPercentage"
                                                />
                                            </td>
                                            <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                                <input
                                                    value={item.DiscountAmount || 0}
                                                    readOnly
                                                    className="w-full px-1 py-1 border rounded-md"
                                                    style={{ fontSize: '13px', fontWeight: 'bold', textAlign: 'right' }}
                                                />
                                            </td>
                                            <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                                <input
                                                    value={item.TaxableAmount || 0}
                                                    className="w-full px-1 py-1 border rounded-md"
                                                    style={{ fontSize: '13px', fontWeight: 'bold', textAlign: 'right' }}
                                                    readOnly
                                                />
                                            </td>
                                            <td style={{ padding: '3px', textAlign: 'right', width: '80px' }}>
                                                <input
                                                    value={parseFloat(item.CGSTAmount) + parseFloat(item.SGSTAmount) + parseFloat(item.IGSTAmount)}
                                                    className="px-1 py-1 border rounded-md"
                                                    style={{
                                                        fontSize: '13px',
                                                        fontWeight: 'bold',
                                                        textAlign: 'right',
                                                        width: '70%', // Adjust the width to fit
                                                    }}
                                                    readOnly
                                                />
                                                <span style={{ marginLeft: '3px', color: 'darkmagenta', fontSize: '11px', fontWeight: 'bold', }}>
                                                    {item.GSTRate ? parseFloat(item.GSTRate).toString() : 0}%
                                                </span>
                                            </td>
                                            <td style={{ padding: '3px', textAlign: 'right', width: '80px' }}>
                                                <input
                                                    value={item.TotalAmount || 0}
                                                    readOnly
                                                    className="w-full px-1 py-1 border rounded-md"
                                                    style={{ fontSize: '13px', fontWeight: 'bold', backgroundColor: '#C7D9DD', textAlign: 'right' }}
                                                />
                                            </td>

                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
        </div >
    );
};

export default PurchaseCreate;
